import React from 'react';
import OurHeader from "./header/OurHeader";
import HeaderTopNews from "./header/HeaderTopNews";
import Copyright from "./footer/Copyright";

const Layout = ({children}) => {
    return (
        <>
            <main className="page-wrapper">
                <HeaderTopNews/>
                <OurHeader btnStyle="btn-small round btn-icon" HeaderSTyle="header-not-transparent"/>
                {children}
                <Copyright/>
            </main>
        </>
    )
}
export default Layout;
